(function initProductInfoTabs() {
  function setup() {
    /* Find every tabs component on the page (supports multiple sections) */
    document.querySelectorAll('.pit-nav').forEach(function (nav) {
      var container = nav.closest('.pit-section');
      if (!container || nav._pitInitialised) return;
      nav._pitInitialised = true;
 
      var panels = container.querySelectorAll('.pit-panel');
 
      /*
       * Hide all panels via inline style.display — this beats any
       * theme CSS that might override class-based display:none rules.
       * Only the active panel gets display:block.
       */
      function setAllPanelsHidden() {
        panels.forEach(function (panel) {
          panel.style.display = 'none';
          panel.classList.remove('is-active');
        });
      }
 
      /* Activate a tab + its matching panel by panel ID */
      function activateTab(tab) {
        var targetId = tab.getAttribute('data-pit-target');
 
        /* Update tab buttons */
        nav.querySelectorAll('.pit-tab').forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
 
        /* Update panels — inline style ensures display is applied */
        panels.forEach(function (panel) {
          var active = panel.id === targetId;
          panel.style.display = active ? 'block' : 'none';
          /* Small delay so the browser registers display:block before
             the opacity transition starts */
          if (active) {
            requestAnimationFrame(function () {
              panel.classList.add('is-active');
            });
          } else {
            panel.classList.remove('is-active');
          }
        });
      }
 
      /* Initialise panel visibility via inline styles on page load */
      var firstActiveTab = nav.querySelector('.pit-tab.is-active');
      setAllPanelsHidden();
      if (firstActiveTab) {
        var firstTargetId = firstActiveTab.getAttribute('data-pit-target');
        var firstPanel = container.querySelector('#' + firstTargetId);
        if (firstPanel) {
          firstPanel.style.display = 'block';
          firstPanel.classList.add('is-active');
        }
      }
 
      /* Single delegated listener on the nav element */
      nav.addEventListener('click', function (e) {
        var tab = e.target.closest('.pit-tab');
        if (!tab) return;
        e.preventDefault();
        activateTab(tab);
      });
 
      /* Keyboard: arrow keys cycle through tabs */
      nav.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        var tabs = Array.from(nav.querySelectorAll('.pit-tab'));
        var idx  = tabs.indexOf(document.activeElement);
        if (idx === -1) return;
        var next = e.key === 'ArrowRight'
          ? tabs[(idx + 1) % tabs.length]
          : tabs[(idx - 1 + tabs.length) % tabs.length];
        next.focus();
        activateTab(next);
      });
    });
  }
 
  /* Run immediately if DOM is ready, otherwise wait */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
 
  /*
   * Re-init after Shopify's theme editor re-renders the section
   * (fires when content is updated in the Customize panel)
   */
  document.addEventListener('shopify:section:load', setup);
})();